import { render, staticRenderFns } from "./Ganadores.vue?vue&type=template&id=2d78c0fe&scoped=true&"
import script from "./Ganadores.vue?vue&type=script&lang=js&"
export * from "./Ganadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78c0fe",
  null
  
)

export default component.exports